module.exports = __webpack_public_path__ + "img/marcus-hero.45054203.png";